import React from 'react';
import logo from './andoid-512.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Art of Street
        </p>
        <p>
          For all technical issues and support please contact: 
        </p>
        <a
          className="App-link"
          href="#"
          rel="noopener noreferrer"
        >
          art.of.street.email@gmail.com
        </a>
      </header>
    </div>
  );
}

export default App;
